export default "__VITE_ASSET__BJui5jHf__"